import { MessageFormatElement } from 'react-intl'
import {
  MaybeLocalizedBusinessLanguageOptions,
  MaybeLocalizedLinks,
  MaybeLocalizedOptionsList,
  MaybeLocalizedPaymentOptions,
  MaybeNestedMessagesType,
  NestedMessagesType
} from '../components'

const recursiveFlattenMessages = (
  nestedMessages: MaybeNestedMessagesType,
  prefix = ''
) => {
  if (!nestedMessages) {
    return {}
  }
  return Object.keys(nestedMessages).reduce<NestedMessagesType>(
    (messages, key) => {
      const value = nestedMessages[key]
      const prefixedKey = prefix ? `${prefix}.${key}` : key

      if (typeof value === 'string') {
        Object.assign(messages, { [prefixedKey]: value })
      } else {
        Object.assign(
          messages,
          recursiveFlattenMessages(value as NestedMessagesType, prefixedKey)
        )
      }
      return messages
    },
    {}
  )
}

export const flattenMessages = (
  nestedMessages: MaybeNestedMessagesType,
  localizedOptionsLists?: MaybeLocalizedOptionsList,
  localizedLinks?: MaybeLocalizedLinks,
  localizedBusinessLanguagesOptions?: MaybeLocalizedBusinessLanguageOptions,
  localizedPaymentOptions?: MaybeLocalizedPaymentOptions
) => {
  return Object.assign(
    recursiveFlattenMessages(nestedMessages),
    localizedOptionsLists,
    localizedLinks,
    localizedBusinessLanguagesOptions,
    localizedPaymentOptions
  ) as Record<string, MessageFormatElement[]>
}
